module.exports = __webpack_public_path__ + "media/img/apple-icon-114x114-7e86fa06c9b2f4cc6cda74e9926bbab2.png";